export default __webpack_public_path__ + "static/media/fire_permits.58df7c49.pdf";